import { GavelRounded, GraphicEq } from '@mui/icons-material';

function SendRecordingsHeader() {
    return <div id="sendrecording" className="px-24 bg-stop-it-red pt-5 pb-5 flex flex-row justify-left space-x-8 text-white">
        <GavelRounded className="scale-150 pt-1"/>
        <p className="font-semibold text-2xl">Send recording</p>
    </div>;
}

export default SendRecordingsHeader;